var map = {
	"./angry-40.png": "7M+g",
	"./embrace-40.png": "Uj5s",
	"./emotional-40.png": "fuKe",
	"./happy-40.png": "N/At",
	"./like-40.png": "j3ox"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ga0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emojis ^\.\/.*\-40\.png$
// module id = 9ga0
// module chunks = 1